<template>
  <div :class="[`fw-filterelem-filter`, `fw-filterelem-filter-number`]">
    <div class="fw-filterelem-filter-content">
      <PrimeVueInputNumber
        v-model="localValue"
        :step="stepValue"
        :min="minValue"
        :max="maxValue"
        :placeholder="props.placeholder ?? `Wert eingeben`"
        allow-empty
        show-buttons
        button-layout="horizontal"
        fluid
      />
    </div>
    <div class="fw-filterelem-filter-actions">
      <PrimeVueButton class="action-save" @click="applyFilter">
        {{ languageStrings.apply[languageStore.language] }}
      </PrimeVueButton>
      <Transition name="filterpel-fade">
        <PrimeVueButton v-if="localValue" class="action-clear p-button-secondary" @click="clearFilter">
          {{ languageStrings.reset[languageStore.language] }}
        </PrimeVueButton>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';

import { default as PrimeVueInputNumber } from 'primevue/inputnumber';
import { default as PrimeVueButton } from 'primevue/button';

import useLanguageStore from "@/stores/language";

// define props & emits
const props = defineProps<{
  modelValue: unknown,
  step?: number,
  min?: number,
  max?: number,
  placeholder?: string,
}>();
const emit = defineEmits<{
  "update:modelValue": [value: number | undefined]
  "applyFilter": [value: string]
  "clearFilter": []
  "closeDropdown": []
}>();

// define stores
const languageStore = useLanguageStore();

// define language strings
const languageStrings: ILanguageStrings = {
  apply: {
    de: "Anwenden",
    en: "Apply"
  },
  reset: {
    de: "Zurücksetzen",
    en: "Reset"
  }
};

// define value
const localValue = ref();
watch(() => props.modelValue, (newValue) => {
  localValue.value = newValue ?? undefined;
});

// define computed
const stepValue = computed(() => props.step ?? 1);
const minValue = computed(() => props.min ?? 0);
const maxValue = computed(() => props.max ?? 1000);

// on submit change model value
const applyFilter = () => {
  // if empty, clear and close dropdown
  if (localValue.value === undefined) {
    clearFilter();
    closeDropdown();
    return;
  }

  // else submit new values
  emit("update:modelValue", localValue.value);
  emit("applyFilter", localValue.value);
};

// on clear reset model value
const clearFilter = () => {
  localValue.value = undefined;
  emit("update:modelValue", undefined);
  emit("clearFilter");
};

// close dropdown
const closeDropdown = () => {
  emit("closeDropdown");
};

</script>
